import React from 'react'

import {
  array, bool, func, number,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'
import useBreakpoint from 'Utils/useBreakpoint'

import Carousel from './Carousel'

function Images({
  isLoading,
  galleryImageUrls = EMPTY_ARRAY,
  onActiveIndexChange,
  fullScreenGallery = false,
  activeIndex,
  totalCount,
}) {
  const largeUrls = galleryImageUrls.map((item) => item.largeUrl)
  const showInlineGallery = !['xs', 'sm'].includes(useBreakpoint())

  if (isLoading) {
    return (
      <div className="cgt-model-gallery-new__images">
        <div className="cgt-model-card__image-container" />
      </div>
    )
  }

  return (
    <div className="cgt-model-gallery-new__images">
      <Carousel
        slides={largeUrls}
        onActiveIndexChange={onActiveIndexChange}
        highlightActive={showInlineGallery}
        fullScreenGallery={fullScreenGallery}
        activeIndex={activeIndex}
        totalCount={totalCount}
      />
    </div>
  )
}

Images.propTypes = {
  isLoading: bool.isRequired,
  galleryImageUrls: array,
  onActiveIndexChange: func.isRequired,
  fullScreenGallery: bool,
  activeIndex: number.isRequired,
  totalCount: number.isRequired,
}

export default Images
